(function () {
    'use strict';

    angular
        .module('app.memberAdmin')
        .component('sc3IgnMembershipList', {
            templateUrl: 'app/member-admin/ign-membership/ign-membership-list.component.html',
            controller: IgnMembershipListComponent,
            bindings: {
                individualId: '<',
                memberships: '<',
                ignAssociations: '<'
            }
        });

    var noop = angular.noop

    IgnMembershipListComponent.$inject = ['$scope', 'Member', 'confirm', 'alert', 'memberAdminResources'];
    function IgnMembershipListComponent($scope, Member, confirm, alert, resources) {
        var ctrl = this;
        ctrl.memberships = [];
        ctrl.insert = insert
        ctrl.remove = remove;
        ctrl.sendScoresToUSGA = sendScoresToUSGA;

        //////////////////////

        function sendScoresToUSGA() {
            //var individualId = member.individualId;

            confirm(resources.sendScoreToUSGAConfirmation).then(sendScoresToUSGA, noop);

            function sendScoresToUSGA() {
                Member.sendScoresToUSGA({ id: ctrl.individualId }, success, error, true);

                function success() {                    
                    alert.success(resources.sendScoreToUSGASuccess);
                }
                function error() {
                    alert.error(resources.sendScoreToUSGAFailed);
                }
            }
        }


        function insert() {
            ctrl.memberships.push({ individualId: ctrl.individualId, isNew: true, $editing: true });
        }

        function remove(link) {
            var index = ctrl.memberships.indexOf(link);
            if (index >= 0)
                ctrl.memberships.splice(index, 1);
        }
    }
})();